import React from "react";
import {
  Field as ReactFinalFormField,
  Form as ReactFinalFormForm,
} from "react-final-form";
import arrayMutators from "final-form-arrays";
import { FieldArray as reactFinalForm_FieldArray } from "react-final-form-arrays";

import console from '../functions/console';

class OnChangeState extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      previous: props.input.value
    };
  }

  componentDidUpdate() {
    const { children, input: { value } } = this.props;
    const { previous } = this.state;
    if (value !== previous) {
      this.setState({ previous: value });
      children(value, previous);
    }
  }

  render() {
    return null;
  }
}

const OnChange = ({ name, children }) =>
  React.createElement(Field, {
    name,
    subscription: { value: true },
    allowNull: true,
    render: props => React.createElement(OnChangeState, { ...props, children })
  })
/*
import {
  reduxForm,
  Form as reduxForm_Form,
  Field as reduxForm_Field,
  FieldArray as reduxForm_FieldArray,
  reducer as reduxForm_reducer,
  change as reduxForm_change,
  untouch as reduxForm_untouch
} from "redux-form";
*/

// abstract from different form-libraries like redux-form or react-final-form

const useForm = {
  /*
    redux: {
      connectForm: reduxForm,
      Form: reduxForm_Form,
      Field: reduxForm_Field,
      FieldArray: reduxForm_FieldArray,
      reducer: reduxForm_reducer,
      change: reduxForm_change,
      untouch: reduxForm_untouch,
    },
  */
  reactFinalForm: {
    connectForm: ({ form, ...config }) => Component => props => {
      /*
      const onSubmit = typeof props.onSubmit === "function"
        ? props.onSubmit
        : (args, formProps, complete) => {
          console.log("submit", args, formProps, complete, form, config);
          return args;
        };
      */
      const mutators = { ...arrayMutators };
      return (
        <Component {...props} {...config} mutators={mutators} />
      );
      /*
        <ReactFinalFormForm subscription={{valid:true}} {...config} mutators={mutators} component={component} {...props} onSubmit={onSubmit}>
        </ReactFinalFormForm>
      ReactFinalFormForm({ ...config, ...props, component, onSubmit, mutators })
      */
    },
    Form: ReactFinalFormForm,
    Field: (props) => {
      let { validate, ...rest } = props;
      /* in redux-form the validate can be a array of functions */
      if (typeof validate !== "function") {
        if (Array.isArray(validate)) {
          const validateFunctions = validate.filter(v => typeof v === "function");
          if (validateFunctions.length) {
            validate = (value) => {
              for (let f of validateFunctions) {
                let validated = f(value);
                if (validated) return validated;
              }
              return undefined;
            };
          } else {
            validate = undefined;
          }
        } else {
          validate = undefined;
        }
      }
      return (<ReactFinalFormField validate={validate} {...rest} />);
    },
    FieldArray: reactFinalForm_FieldArray,
    reducer: (...args) => {
      console.debug("reducer", args);
      return { action: "INIT_FORM", payload: "init" };
    },
    change: (...args) => {
      console.debug("change", args);
    },
    untouch: (...args) => {
      console.debug("untouch", args);
    }
  }
};

const use = "reactFinalForm";
const connectForm = useForm[use].connectForm;
const Form = useForm[use].Form;
const Field = useForm[use].Field;
const FieldArray = useForm[use].FieldArray;
const reducer = useForm[use].reducer;
const change = useForm[use].change;
const untouch = useForm[use].untouch;

export {
  connectForm,
  Form,
  Field,
  FieldArray,
  OnChange,
  reducer,
  change,
  untouch
};
